import React, { useState } from "react";
import { classNames } from "lib/utils/helpers";

interface BrandLogoImageProps {
  src?: string;
  alt: string;
  className?: string;
  skeletonClassName?: string;
}

// Shows a skeleton-loader in place of a brand/partner logo until the image has finished loading.
// Hides itself entirely if the image fails to load.
const BrandLogoImage: React.FC<BrandLogoImageProps> = ({ src, alt, className, skeletonClassName }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasErrored, setHasErrored] = useState(false);

  if (!src || hasErrored) return null;

  return (
    <>
      {!isLoaded && <div className={classNames("skeleton-loader", skeletonClassName ?? className ?? "")} />}
      <img
        src={src}
        alt={alt}
        className={classNames(className ?? "", isLoaded ? "" : "hidden")}
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasErrored(true)}
      />
    </>
  );
};

export default BrandLogoImage;
